class MediaContentCaptions {
	static captionsLine = 84;
	static maxPositionAttempts = 12;
	static instancesByVideoId = new Map();

	constructor(el) {
		this.el = el;
		this.video = document.getElementById(el.dataset.videoId);

		if (!this.video) return;

		this.trackEl = this.video.querySelector('track[kind="captions"]');
		this.track = this.getCaptionsTrack();

		if (!this.track) {
			this.el.hidden = true;
			return;
		}

		const videoId = el.dataset.videoId;
		if (!MediaContentCaptions.instancesByVideoId.has(videoId)) {
			MediaContentCaptions.instancesByVideoId.set(videoId, []);
		}
		MediaContentCaptions.instancesByVideoId.get(videoId).push(this);

		this.setCaptionsEnabled(this.el.getAttribute('aria-pressed') === 'true', false);
		this.video.addEventListener('loadedmetadata', () => this.schedulePositionCues());
		if (this.trackEl) {
			this.trackEl.addEventListener('load', () => this.schedulePositionCues());
		}
		this.track.addEventListener('cuechange', () => this.positionCues());
		this.el.addEventListener('click', () => this.setCaptionsEnabled(this.el.getAttribute('aria-pressed') !== 'true', true));
	}

	getCaptionsTrack() {
		const tracks = Array.from(this.video.textTracks || []);

		return tracks.find((track) => track.kind === 'captions');
	}

	setCaptionsEnabled(enabled, syncSiblings = true) {
		this.track.mode = enabled ? 'showing' : 'hidden';
		this.schedulePositionCues();
		this.applyButtonState(this.el, enabled);

		if (syncSiblings) {
			const siblings = MediaContentCaptions.instancesByVideoId.get(this.el.dataset.videoId) || [];
			siblings.forEach((instance) => {
				if (instance !== this) {
					instance.applyButtonState(instance.el, enabled);
				}
			});
		}
	}

	applyButtonState(el, enabled) {
		el.classList.toggle('is-active', enabled);
		el.setAttribute('aria-pressed', enabled ? 'true' : 'false');
		el.setAttribute('aria-label', enabled ? 'Turn captions off' : 'Turn captions on');
	}

	schedulePositionCues() {
		this.positionCuesWithRetries();
		requestAnimationFrame(() => this.positionCuesWithRetries());
		setTimeout(() => this.positionCuesWithRetries(), 100);
	}

	positionCuesWithRetries(attempt = 0) {
		const positioned = this.positionCues();

		if (!positioned && attempt < MediaContentCaptions.maxPositionAttempts) {
			setTimeout(() => this.positionCuesWithRetries(attempt + 1), 100);
		}
	}

	positionCues() {
		if (!this.track || !this.track.cues || !this.track.cues.length) return false;

		Array.from(this.track.cues).forEach((cue) => {
			if ('snapToLines' in cue) {
				cue.snapToLines = false;
			}

			if ('line' in cue) {
				cue.line = MediaContentCaptions.captionsLine;
			}
		});

		return true;
	}
}

export default MediaContentCaptions;